import * as Yup from 'yup';

export const CreateRackSchema = Yup.object().shape({
  // binCount: Yup.string().min(2).required('Please provide bin count'),
  binCount: Yup.number().min(0).required('Please provide bin count'),
  rackName: Yup.string().min(2).required('Please provide rack name'),
  rackType: Yup.string().min(2).required('Please provide rack type'),
  rackStatus: Yup.string().min(2).required('Please provide rack status'),
});

export type CreateRackDataType = Yup.InferType<typeof CreateRackSchema>;

type InitialValues = {
  binCount: number;
  rackName: string;
  rackType: string;
  rackStatus: string;
};

export const createRackInitialValues: InitialValues = {
  binCount: 0,
  rackName: '',
  rackType: '',
  rackStatus: '',
};

export interface ICreateRackResponse {
  rackId: string;
  warehouseId: string;
  rackLocation: string;
  rackName: string;
  rackType: string;
  rackStatus: boolean;
  binCount: number;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  createdBy: string;
  createdDate: string;
}

export interface ICreateRackRequest {
  binCount: number;
  rackName: string;
  rackType: string;
  rackStatus: boolean;
  warehouseId: string;
}
